import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class DataService {
private baseUrl:any="https://emc2academy.com/manage_app/"
  constructor(public http: HttpClient) { }

  public getcountry_list(){
    return this.http.get('../assets/json/CountryCodes.json')
}

public getcountry_name_list(){
  return this.http.get('../assets/json/countries.json')
}


public user_register(post_params){
  
    let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
    return this.http.post(this.baseUrl+"sign_in/registration_submit/",JSON.stringify(post_params),headers)

}

public login(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json', })
  return this.http.post(this.baseUrl+"sign_in/login_action/",JSON.stringify(post_params),headers)

}

public otp_verify(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':this.baseUrl })
  return this.http.post(this.baseUrl+"sign_in/otp_verify/",JSON.stringify(post_params),headers)

}

public savedevicetoken(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json'})
  return this.http.post(this.baseUrl+'push_notification/update_token',JSON.stringify(post_params),headers)

}

public password_checking(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/check_old_password/",JSON.stringify(post_params),headers)

}

public update_password(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/change_password_action/",JSON.stringify(post_params),headers)

}

public update_profile_image(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"/category/img_update/",JSON.stringify(post_params),headers)

}
public get_my_profile(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/myaccount/",JSON.stringify(post_params),headers)

}

public get_my_profile_and_create_order(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/myaccount_create_order/",JSON.stringify(post_params),headers)

}

public update_profile(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/user_profile_update/",JSON.stringify(post_params),headers)

}
public get_category(){
  return this.http.get(this.baseUrl+"category/get_category_listt/")
}

public get_sub_category(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*' })
  return this.http.post(this.baseUrl+"category/get_subcategory_new/",JSON.stringify(post_params),headers)

}

public get_question_for_download(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*' })
  return this.http.post(this.baseUrl+"category/test_qs_download/",JSON.stringify(post_params),headers)

}

public get_video_list(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/get_video_list/",JSON.stringify(post_params),headers)

}
public get_popular_video(){
  return this.http.get(this.baseUrl+"/category/get_pop_video/")
}
public get_note_list(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/get_video_note/",JSON.stringify(post_params),headers)

}

public get_video_doubt(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/get_video_doubt/",JSON.stringify(post_params),headers)

}

public add_video_doubt(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/user_doubt_add/",JSON.stringify(post_params),headers)

}

public checking_video_beforeplay(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/video_click/",JSON.stringify(post_params),headers)

}

public checking_video_beforeplay_uppdaed(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/video_click_update/",JSON.stringify(post_params),headers)

}
public check_user_id(postparams)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/check_user_id/",JSON.stringify(postparams),headers)
}

public submit_query(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/query_submit/",JSON.stringify(post_params),headers)
}

public book_videos(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/book_videos/",JSON.stringify(post_params),headers)

}
public check_exam(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*',})
  return this.http.post(this.baseUrl+"Manage_exam/check_exam/",JSON.stringify(post_params),headers)
}

public get_test_list(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*',})
  return this.http.post(this.baseUrl+"category/get_all_test_list/",JSON.stringify(post_params),headers)
}

public get_my_test(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json','Access-Control-Allow-Origin':'*',})
  return this.http.post(this.baseUrl+"category/get_my_test/",JSON.stringify(post_params),headers)
}

public get_notification(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"push_notification/getnotification/",JSON.stringify(post_params),headers)
}

public generate_user_test(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"User_dashboard/generate_user_test",JSON.stringify(post_params),headers)
}

public start_exam(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/start_examination",JSON.stringify(post_params),headers)
}

save_next_question(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/save_next_question_app",JSON.stringify(post_params),headers)
}
remove_question(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/remove_question",JSON.stringify(post_params),headers)
}
submit_test(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/submit_test_app",JSON.stringify(post_params),headers)
}

getExamSummary(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/exam_summary",JSON.stringify(post_params),headers)
}
get_analysis_report(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"Manage_exam/analysis",JSON.stringify(post_params),headers)
}
get_exam_report(post_params)
{
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"My_profile/exam_report",JSON.stringify(post_params),headers)
}


public is_view_notofication(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"push_notification/is_view_notification/",JSON.stringify(post_params),headers)
}

public get_my_sub(post_params){
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"category/my_video",JSON.stringify(post_params),headers)
}

public get_help_data(){
  return this.http.get(this.baseUrl+"category/get_help_data/")
}

public get_plan(){
  return this.http.get(this.baseUrl+"category/all_plan/")
}
public all_video_bundle_plan(){
  return this.http.get(this.baseUrl+"category/all_video_bundle_plan/")
}

public get_contact_info(){
  return this.http.get(this.baseUrl+"category/get_contact/")
}

public get_slider(){
  return this.http.get(this.baseUrl+"category/get_category/")
}


public get_privecy(){
  return this.http.get(this.baseUrl+"category/privacy/")
}

public get_term(){
  return this.http.get(this.baseUrl+"category/terms/")
}


public get_about(){
  return this.http.get(this.baseUrl+"category/about/")
}























public get_faq(){
  
  return this.http.get(this.baseUrl+"pages/get_faq/")

}

public gel_all_home_data(){
  
  return this.http.get(this.baseUrl+"home/all_data/")

}


public add_to_cart(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/add_to_cart/",JSON.stringify(post_params),headers)

}

public get_all_produtc(){
  
  return this.http.get(this.baseUrl+"home/get_all_products")

}
public product_details(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home/get_all_product_details/",JSON.stringify(post_params),headers)

}

public viewCart(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/cart_list_view/",JSON.stringify(post_params),headers)

}

public delete_item_from_cart(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/delete_my_cart",JSON.stringify(post_params),headers)

}

public qty_incriment(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/updated_my_cart/",JSON.stringify(post_params),headers)

}

public qty_dicriment(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/updated_my_cart/",JSON.stringify(post_params),headers)

}

public add_to_wish_list(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"wishlist/add_wishlist/",JSON.stringify(post_params),headers)

}
public view_wish_list(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"wishlist/view_list/",JSON.stringify(post_params),headers)

}

public delete_wish_list(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"wishlist/remove_wishlist/",JSON.stringify(post_params),headers)

}

public my_ticket(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home/active_ticket/",JSON.stringify(post_params),headers)

}

public place_order(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"manage_cart/place_order",JSON.stringify(post_params),headers)

}
public forgotpassword(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"sign_in/forogot_password",JSON.stringify(post_params),headers)

}

public prizeDetails(post_params){
  
  let headers:any=new HttpHeaders({ 'Content-Type': 'application/json' })
  return this.http.post(this.baseUrl+"home/prizedetails",JSON.stringify(post_params),headers)

}
public get_contact_details(){
  
  
  return this.http.get(this.baseUrl+"home/get_contact_details")

}

}
